import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import usePrevious from '../../hooks/usePrevious';

const Reloadable = ({ children }) => {
  const location = useLocation();
  const prevLocation = usePrevious(location);

  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      const timeout = setTimeout(() => {
        setReloading(false);
      });
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [reloading]);

  useEffect(() => {
    if (!prevLocation) return;
    if (
      location.pathname === prevLocation.pathname &&
      location.search === prevLocation.search &&
      location.hash === prevLocation.hash &&
      location.key !== prevLocation.key
    ) {
      setReloading(true);
    }
  }, [JSON.stringify(location), JSON.stringify(prevLocation)]);

  return reloading ? null : children;
};

export const reloadable = Component => props =>
  (
    <Reloadable>
      <Component {...props} />
    </Reloadable>
  );

export default Reloadable;
